// Skeleton — data-region loading placeholder per COMPONENTS §Catalog.
//
// The "loading" arm of the 5-state contract for DATA regions (table rows, future
// chart areas) — distinct from the shell loaders (Spinner / PageLoader /
// RouteProgress, which cover in-control + navigation loading). Decorative
// (aria-hidden); the surrounding region owns the role="status" announcement, so
// the skeleton conveys nothing on its own. The pulse is neutralized to static
// under prefers-reduced-motion by the global block in index.css.

export type SkeletonVariant = 'text' | 'rect' | 'circle';

export interface SkeletonProps {
  variant?: SkeletonVariant;
  /** CSS width — number → px, string → as-is. Default '100%'. */
  width?: string | number;
  /** CSS height — number → px, string → as-is. Default: text → 0.875rem. */
  height?: string | number;
  className?: string;
}

const shape: Record<SkeletonVariant, string> = {
  text: 'rounded-md',
  rect: 'rounded-md',
  circle: 'rounded-full',
};

function dim(v: string | number | undefined): string | undefined {
  if (v === undefined) return undefined;
  return typeof v === 'number' ? `${v}px` : v;
}

export function Skeleton({ variant = 'text', width = '100%', height, className = '' }: SkeletonProps) {
  return (
    <span
      aria-hidden="true"
      className={`block animate-pulse bg-[var(--color-bg-surface-alt)] ${shape[variant]} ${className}`}
      style={{ width: dim(width), height: dim(height ?? (variant === 'text' ? '0.875rem' : '2.5rem')) }}
    />
  );
}
